const state = {
  sidepanels: [],
  toasts: []
};

const getters = {
  sidepanels: state => state.sidepanels,
  sidepanelCount: state => state.sidepanels.length,
  panelDepth: state => id => {
    return (
      state.sidepanels.length -
      1 -
      state.sidepanels.findIndex(panel => panel.id === id)
    );
  },
  sidepanel: state => id => {
    const panels = state.sidepanels.filter(panel => panel.id === id);
    if (panels.length > 0) return panels[0];
    return null;
  },
  toasts: state => state.toasts,
  toastDepth: state => id => {
    return (
      state.toasts.length - 1 - state.toasts.findIndex(toast => toast.id === id)
    );
  }
};

const mutations = {
  ADD_PANEL(state, payload) {
    if (state.sidepanels.filter(elem => elem.id === payload.id).length === 0) {
      state.sidepanels.push(payload);
    }
  },
  REMOVE_PANEL(state) {
    if (state.sidepanels.length > 0) state.sidepanels.splice(-1, 1);
  },
  REMOVE_ALL_PANELS(state) {
    state.sidepanels.splice(0, state.sidepanels.length);
  },
  ADD_TOAST(state, payload) {
    payload.id = Math.floor(Math.random() * 100000000);
    state.toasts.push(payload);
    setTimeout(() => {
      const index = state.toasts.findIndex(toast => toast.id === payload.id);
      state.toasts.splice(index, 1);
    }, 2000);
  },
  REMOVE_TOAST(state) {
    state.toasts.splice(-1, 1);
  },
  REMOVE_ALL_TOASTS(state) {
    state.toasts.splice(0, state.toasts.length);
  }
};

const actions = {
  addPanel: function(context, payload) {
    context.commit("ADD_PANEL", payload);
  },
  removePanel: function(context) {
    context.commit("REMOVE_PANEL");
  },
  removeAllPanels: function(context) {
    context.commit("REMOVE_ALL_PANELS");
  },
  addToast: function(context, payload) {
    context.commit("ADD_TOAST", payload);
  },
  removeToast: function(context) {
    context.commit("REMOVE_TOAST");
  },
  removeAllToasts: function(context) {
    context.commit("REMOVE_ALL_TOASTS");
  }
};

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
};
